var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapsMarkerGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "56px",
    height: "56px",
    viewBox: "0 0 56 56",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icono / Pin") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-25.0%",
    y: "-150.0%",
    width: "150.0%",
    height: "400.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22,7.6564 C22.391,8.0474 22.391,8.6804 22,9.0704 C21.609,9.4614 20.977,9.4614 20.586,9.0704 L19.879,8.3634 L15.986,12.2554 L16.184,12.8434 C16.903,14.9894 16.688,17.2984 15.624,19.2314 C15.31,19.8024 14.517,19.8854 14.057,19.4244 L4.573,9.9394 C4.111,9.4784 4.196,8.6844 4.769,8.3714 C6.703,7.3114 9.012,7.0964 11.157,7.8164 L11.744,8.0134 L15.637,4.1204 L14.931,3.4134 C14.54,3.0234 14.54,2.3904 14.931,1.9994 C15.32,1.6094 15.954,1.6094 16.345,1.9994 L22,7.6564 Z M7.9014,14.6842 L9.3154,16.0982 L3.7074,21.7062 L1.0004,23.0002 L2.2934,20.2932 L7.9014,14.6842 Z",
    id: "path-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icono-/-Pin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fillOpacity: 0.2,
    fill: "#202020",
    filter: "url(#filter-1)",
    cx: 28,
    cy: 50,
    rx: 12,
    ry: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,0 C16.954,0 8,8.954 8,20 C8.167,35.544 28,50 28,50 C28,50 47.833,35.544 48,20 C48,8.954 39.046,0 28,0",
    id: "Pin",
    fill: "#5CB047"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icono-/-Tarea-/-Fill",
    transform: "translate(16.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#000000",
    fillRule: "evenodd",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-White",
    mask: "url(#mask-3)",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-13",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapsMarkerGreen);
export default __webpack_public_path__ + "static/media/maps-marker-green.aeeee7698351da351372e75f0fdb25e5.svg";
export { ForwardRef as ReactComponent };